import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'replaceWithSpaces',
    standalone: false
})
export class ReplaceTextWithSpacesPipe implements PipeTransform {
  //remove underscores _ -
  transform(str: string): string {
    return str.replace(/_/g, ' ').replace(/-/g, ' ');
  }

}
